export const REDUCER_NAME = 'logistic'



// WEBPACK FOOTER //
// ./src/modules/logistic/state/const.js